var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishListPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WishListPublic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wish-Lists",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Customer-Dashboard-\\u2014-Wish-Lists",
    transform: "translate(-909.000000, -523.000000)",
    fill: "#848484",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list-card-copy",
    transform: "translate(735.000000, 362.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "event-basics-in-list-form",
    transform: "translate(17.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock-open",
    transform: "translate(157.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.90643275,0.0233918129 C7.94152047,0.0304093567 6.3625731,1.64912281 6.3625731,3.61403509 L6.3625731,5.26315789 L1.12280702,5.26315789 C0.502923977,5.26315789 0,5.76608187 0,6.38596491 L0,10.877193 C0,11.497076 0.502923977,12 1.12280702,12 L9.35672515,12 C9.97660819,12 10.4795322,11.497076 10.4795322,10.877193 L10.4795322,6.38596491 C10.4795322,5.76608187 9.97660819,5.26315789 9.35672515,5.26315789 L8.23391813,5.26315789 L8.23391813,3.6 C8.23391813,2.67368421 8.9754386,1.90409357 9.90175439,1.89473684 C10.8374269,1.88538012 11.6023392,2.64561404 11.6023392,3.57894737 L11.6023392,5.4502924 C11.6023392,5.76140351 11.8526316,6.01169591 12.1637427,6.01169591 L12.9122807,6.01169591 C13.2233918,6.01169591 13.4736842,5.76140351 13.4736842,5.4502924 L13.4736842,3.57894737 C13.4736842,1.61403509 11.871345,0.016374269 9.90643275,0.0233918129 Z",
    id: "WishListPublic"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishListPublic);
export default __webpack_public_path__ + "static/media/WishListPublic.06a5192b6a65090eef2753e84f601663.svg";
export { ForwardRef as ReactComponent };